/* Olivria 改版交互 —— 选择器均限定在 .ol-scope 内 */
// Olivria theme — 原型交互的最小实现
document.addEventListener('click', function (e) {
  // 手风琴（页脚 / 详情页信息块 / 筛选行）
  var acc = e.target.closest('.ol-scope .faccq, .ol-scope .acc, .ol-scope .frow.acc');
  if (acc) {
    var panel = acc.nextElementSibling;
    if (panel) {
      var open = panel.hasAttribute('hidden');
      if (open) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
      acc.setAttribute('aria-expanded', String(open));
      acc.classList.toggle('op', open);
    }
  }

  // 筛选抽屉开关
  if (e.target.closest('.ol-scope .fbtn')) {
    var drawer = document.querySelector('.ol-scope .ol-filter');
    if (drawer) {
      drawer.classList.toggle('open');
      e.target.closest('.ol-scope .fbtn').classList.toggle('on', drawer.classList.contains('open'));
    }
  }

  // 尺码表弹窗
  if (e.target.closest('.ol-scope .szchart')) {
    var m = document.querySelector('.ol-scope .szmodal');
    if (m) m.removeAttribute('hidden');
  }
  if (e.target.closest('.ol-scope .szx') || e.target.closest('.ol-scope .szscrim')) {
    var m2 = document.querySelector('.ol-scope .szmodal');
    if (m2) m2.setAttribute('hidden', '');
  }

  // 尺码表单位切换 cm / in
  var unit = e.target.closest('.ol-scope .szunit button');
  if (unit) {
    var u = unit.dataset.u;
    unit.parentNode.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b === unit); });
    document.querySelectorAll('.ol-scope .sztab td[data-cm]').forEach(function (td) {
      var cm = parseFloat(td.dataset.cm);
      td.textContent = u === 'in' ? (cm / 2.54).toFixed(1) : String(cm);
    });
  }
});

// 图库横滑计数
document.querySelectorAll('.ol-scope .gtrack').forEach(function (track) {
  var now = document.querySelector('.ol-scope .gnow');
  if (!now) return;
  track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / track.clientWidth) + 1;
    now.textContent = String(i);
  }, { passive: true });
});



// 详情页图库：滚动联动底部圆点（图多于圆点时按比例映射）
document.querySelectorAll('.ol-scope .gtrack').forEach(function (track) {
  var gal = track.closest('.gal');
  var dots = gal ? gal.querySelectorAll('.gdots i') : [];
  if (!dots.length) return;
  track.addEventListener('scroll', function () {
    var total = [].filter.call(track.children, function (x) { return !x.classList.contains('goff'); }).length;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var d = total > 1 ? Math.round(i / (total - 1) * (dots.length - 1)) : 0;
    dots.forEach(function (x, k) { x.classList.toggle('on', k === d); });
  }, { passive: true });
});

// 详情页：颜色/尺码切换 → 选中态 + 变体匹配 + 价格与库存联动
(function () {
  var root = document.querySelector('.ol-scope script[data-ol-variants]');
  if (!root) return;
  var variants; try { variants = JSON.parse(root.textContent); } catch (e) { return; }
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  function currentSelection() {
    var sel = {};
    form.querySelectorAll('input[type=radio][name^=option]:checked').forEach(function (r) {
      sel[r.name] = r.value;
    });
    return sel;
  }
  function update() {
    var sel = currentSelection();
    // 选中态样式
    form.querySelectorAll('input[type=radio][name^=option]').forEach(function (r) {
      var lb = r.closest('label');
      if (lb) lb.classList.toggle('on', r.checked);
    });
    // 选项名回显：仅当 radio 位于 .optbtns（颜色组）内，更新其相邻 .optlbl
    form.querySelectorAll('input[type=radio][name^=option]:checked').forEach(function (r) {
      var group = r.closest('.optbtns');
      if (!group) return;
      var span = group.parentElement.querySelector('.optlbl span');
      if (span) span.textContent = r.value;
    });
    // 变体匹配
    var v = variants.find(function (x) {
      return ['option1','option2','option3'].every(function (k, i) {
        return !sel[k] && !x[k] || sel[k] === x[k] || (!sel[k] && x[k] == null);
      });
    });
    var idSel = form.querySelector('select[name=id]');
    var btn = form.querySelector('button[type=submit]');
    if (v) {
      if (idSel) idSel.value = v.id;
      // 价格
      var doc = form.closest('.ol-scope') || document;
      var priceEl = doc.querySelector('.price'), wasEl = doc.querySelector('.was'), saveEl = doc.querySelector('.save');
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) wasEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      var pill = doc.querySelector('.pill.sale');
      if (pill) {
        var savedC = v.compare_at_price - v.price;
        pill.textContent = '\u2212$' + (savedC > 0 ? (savedC / 100).toFixed(2).replace(/\.00$/, '') : '');
        pill.parentElement.style.display = savedC > 0 ? '' : 'none';
      }
      if (saveEl) saveEl.textContent = v.compare_at_price > v.price ? 'Save ' + money(v.compare_at_price - v.price) : '';
      document.querySelectorAll('.ol-scope .psku').forEach(function (skuEl) {
        var skuV = skuEl.querySelector('.psku-v');
        if (v.sku) { if (skuV) skuV.textContent = v.sku; skuEl.removeAttribute('hidden'); }
        else skuEl.setAttribute('hidden', '');
      });
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'ADD TO BAG' : 'SOLD OUT'; }
      if (window.olTierNudge) window.olTierNudge(v.price / 100);
      // 切换颜色/尺码时图库跳到该变体主图（不按颜色过滤，全部图片可浏览）
      (function () {
        var track = doc.querySelector('.gtrack');
        if (!track || !v.featured_image || !v.featured_image.position) return;
        var kids = [].slice.call(track.children);
        for (var ki = 0; ki < kids.length; ki++) {
          if (kids[ki].dataset.ipos === String(v.featured_image.position)) {
            track.scrollTo({ left: ki * track.clientWidth, behavior: 'smooth' });
            return;
          }
        }
      })();
    } else if (btn) { btn.disabled = true; btn.textContent = 'UNAVAILABLE'; }
  }
  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type=radio][name^=option]')) update();
  });
  update();
})();

// 购物车 Promo code：经 Shopify 折扣链接写入，结账时生效
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.ol-scope .promo-apply');
  if (!btn) return;
  var input = btn.parentElement.querySelector('.promo-input');
  var code = input && input.value.trim();
  if (!code) { if (input) input.focus(); return; }
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart';
});

// 购物车关闭/继续购物：返回来时的页面；无历史（直开链接）时走链接兜底
document.addEventListener('click', function (e) {
  var back = e.target.closest('.ol-scope .cart-back');
  if (!back) return;
  var ref = document.referrer;
  if (ref && ref.indexOf(location.host) > -1 && ref.indexOf('/cart') === -1 && history.length > 1) {
    e.preventDefault();
    history.back();
  }
  // 否则按 href 正常跳转（首页/列表兜底）
});

// 购物车弹层：样式复用 /cart 页的抽屉，打开方式改为浮层（不跳页）
(function () {
  var overlay = null;
  function ensure() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = 'ol-cart-overlay';
    overlay.className = 'ol-scope';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:none;background:transparent';
    // 挂在 <main id="content"> 下而非 body：XCotton 运费险按 "#content .checkout-buttons button[name=checkout]" 找锚点，
    // 挂 body 下浮层里的结算区匹配不到，面板只会在 /cart 页出现
    (document.getElementById('content') || document.body).appendChild(overlay);
    return overlay;
  }
  function updateBadge(n) {
    document.querySelectorAll('.cart-link__count').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
    });
  }
  function closeCart() {
    if (!overlay) return;
    overlay.style.display = 'none';
    overlay.innerHTML = '';
    document.documentElement.style.overflow = '';
  }
  function openCart() {
    var o = ensure();
    o.style.display = 'block';
    document.documentElement.style.overflow = 'hidden';
    fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var stage = doc.querySelector('.cart-stage');
        if (!stage) { location.href = '/cart'; return; }
        // 浮层场景：背后是真实页面——去掉假页面骨架，舞台底色改透明，只留半透明遮罩
        var under = stage.querySelector('.cart-under');
        if (under) under.remove();
        var badge = doc.querySelector('.cart-link__count');
        if (badge) updateBadge(parseInt(badge.textContent, 10) || 0);
        stage.style.background = 'transparent';
        o.innerHTML = '';
        o.appendChild(stage);
      })
      .catch(function () { location.href = '/cart'; });
  }
  // 打开：点页头购物车图标（/cart 页本身不拦截）
  document.addEventListener('click', function (e) {
    if (location.pathname.replace(/\/$/, '') === '/cart') return;
    var a = e.target.closest('a[href$="/cart"]');
    if (a && !e.target.closest('#ol-cart-overlay')) { e.preventDefault(); openCart(); }
  }, true);
  // 关闭：✕ / 遮罩 / 继续购物 —— 只收起浮层，停留原页
  document.addEventListener('click', function (e) {
    if (!overlay || overlay.style.display === 'none') return;
    var back = e.target.closest('#ol-cart-overlay .cart-back');
    if (back) { e.preventDefault(); e.stopPropagation(); closeCart(); }
  }, true);
  // 浮层内数量加减/移除：走 change.js JSON 接口 + 局部更新（免整页重拉）
  var changing = false;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  document.addEventListener('click', function (e) {
    if (!overlay || overlay.style.display === 'none') return;
    var a = e.target.closest('#ol-cart-overlay .qty a, #ol-cart-overlay .cact a');
    if (!a) return;
    e.preventDefault(); e.stopPropagation();
    if (changing) return;
    var href = a.getAttribute('href') || '';
    var mLine = href.match(/line=(\d+)/), mQty = href.match(/quantity=(\d+)/);
    if (!mLine || !mQty) { fetch(href).then(function () { openCart(); }); return; }
    var line = +mLine[1], qty = +mQty[1];
    var row = a.closest('.citem');
    changing = true;
    if (row) row.style.opacity = '.45';
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      changing = false;
      if (!cart || cart.item_count === 0 || !cart.items) { openCart(); return; }
      var rows = overlay.querySelectorAll('.citem');
      if (rows.length !== cart.items.length) { openCart(); return; }  // 行数变化（移除/清零）→ 整体刷新
      cart.items.forEach(function (it, i) {
        var el = rows[i];
        var qb = el.querySelector('.qty b');
        if (qb) qb.textContent = it.quantity;
        var priceEl = el.querySelector('.row b:last-child');
        if (priceEl) priceEl.textContent = money(it.final_line_price);
        // 同步加减链接里的数量参数
        var dec = el.querySelector('.qty a[aria-label="Decrease"]');
        var inc = el.querySelector('.qty a[aria-label="Increase"]');
        if (dec) dec.setAttribute('href', '/cart/change?line=' + (i + 1) + '&quantity=' + (it.quantity - 1));
        if (inc) inc.setAttribute('href', '/cart/change?line=' + (i + 1) + '&quantity=' + (it.quantity + 1));
        el.style.opacity = '';
      });
      overlay.querySelectorAll('.bag-hd .note b, .cart-cnt').forEach(function (c) { c.textContent = cart.item_count; });
      updateBadge(cart.item_count);
      var sub = overlay.querySelector('.subval');
      if (sub) sub.textContent = money(cart.original_total_price);
      var btn = overlay.querySelector('.btn.cart');
      if (btn) btn.innerHTML = 'CHECKOUT &middot; ' + money(cart.total_price);  // 与模板一致：不带件数（XCotton 会改写按钮内数字）
    }).catch(function () { changing = false; openCart(); });
  }, true);
  // 加购：AJAX 提交后弹出购物车（不再整页跳转）
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { if (r.ok) { openCart(); } else { location.href = '/cart'; } })
      .catch(function () { location.href = '/cart'; });
  }, true);
})();

// 列表卡：主图轨道滚动 ↔ 圆点/缩略图联动；点缩略图滚到对应图
(function () {
  function bind(track) {
    if (track.dataset.olBound) return;
    track.dataset.olBound = '1';
    var card = track.closest('.pcard, .card');
    if (!card) return;
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        card.querySelectorAll('.imgdots i').forEach(function (d, k) { d.classList.toggle('on', k === i); });
        var swis = card.querySelectorAll('.swi');
        swis.forEach(function (x, k) { x.classList.toggle('on', k === i); });
        if (swis[i] && swis[i].scrollIntoView) swis[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }, 80);
    }, { passive: true });
  }
  function bindAll() { document.querySelectorAll('.ol-scope .pcard .pimgs, .ol-scope .card .pimgs').forEach(bind); }
  bindAll();
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('click', function (e) {
    var swi = e.target.closest('.ol-scope .swi');
    if (!swi) return;
    var card = swi.closest('.pcard, .card');
    var track = card && card.querySelector('.pimgs');
    if (!track) return;
    e.preventDefault();
    var idx = [].indexOf.call(swi.parentNode.querySelectorAll('.swi'), swi);
    track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
  }, true);
})();

// 首页轮播：滑动切换 + 圆点联动 + 自动轮播
(function () {
  document.querySelectorAll('.ol-scope .hero .hslides').forEach(function (track) {
    var hero = track.closest('.hero');
    var dots = hero ? hero.querySelectorAll('.hdots i') : [];
    var slides = track.querySelectorAll('.s').length;
    if (slides < 2) return;
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function sync() {
      var i = idx();
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' });
      });
    });
    function auto() {
      var n = (idx() + 1) % slides;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }
    var timer = setInterval(auto, 5000);
    ['touchstart', 'pointerdown'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        clearInterval(timer);
        timer = setInterval(auto, 8000);   // 用户交互后放缓自动轮播
      }, { passive: true });
    });
  });
})();

// 横滑楼层内的图片轨道：滑到边界后同一手势接力滚动楼层（嵌套同向滚动解法）
(function () {
  function bindRelay(track) {
    if (track.dataset.olRelay) return;
    var hrow = track.closest('.hrow');
    if (!hrow) return;                     // 仅横滑楼层需要接力
    track.dataset.olRelay = '1';
    var lastX = 0, relaying = false;
    track.addEventListener('touchstart', function (e) {
      lastX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      var x = e.touches[0].clientX;
      var dx = lastX - x;                  // >0 向左滑（看下一张）
      lastX = x;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      var atStart = track.scrollLeft <= 2;
      if ((dx > 0 && atEnd) || (dx < 0 && atStart)) {
        e.preventDefault();                // 图已到边界：手势转交楼层
        if (!relaying) { relaying = true; hrow.style.scrollSnapType = 'none'; }  // 接力期间关掉吸附，否则位移被 snap 弹回
        hrow.scrollLeft += dx;
      }
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        if (relaying) { relaying = false; hrow.style.scrollSnapType = ''; }
      }, { passive: true });
    });
  }
  function bindAllRelay() {
    document.querySelectorAll('.ol-scope .hrow .pimgs').forEach(bindRelay);
  }
  bindAllRelay();
  document.addEventListener('shopify:section:load', bindAllRelay);
})();

// 列表页 LOAD MORE：AJAX 原地追加；达到上限后退化为普通跳转翻页（防长列表卡顿）
(function () {
  var busy = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ol-scope .pager .loadmore');
    if (!btn) return;
    var pager = btn.closest('.pager');
    if (pager.dataset.jump === '1') return;          // 已达上限：走普通跳转
    e.preventDefault();
    if (busy) return;
    busy = true;
    var label = 'LOAD MORE';
    btn.textContent = 'LOADING…';
    fetch(btn.getAttribute('href'), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var newPlp = doc.querySelector('.plp');
        var plp = document.querySelector('.ol-scope .plp');
        if (!newPlp || !plp) { location.href = btn.getAttribute('href'); return; }
        while (newPlp.firstElementChild) plp.appendChild(newPlp.firstElementChild);
        document.dispatchEvent(new Event('shopify:section:load'));   // 新卡片重绑图轨道/接力
        var nextBtn = doc.querySelector('.pager .loadmore');
        var loaded = (parseInt(pager.dataset.loaded || '0', 10)) + 1;
        pager.dataset.loaded = loaded;
        if (!nextBtn) { pager.remove(); return; }
        btn.setAttribute('href', nextBtn.getAttribute('href'));
        var limit = parseInt(pager.dataset.ajaxLimit || '4', 10);
        if (loaded >= limit) {
          pager.dataset.jump = '1';
          btn.textContent = 'VIEW MORE →';           // 上限后转跳转翻页
        } else {
          btn.textContent = label;
        }
      })
      .catch(function () { location.href = btn.getAttribute('href'); })
      .then(function () { busy = false; });
  }, true);
})();

// PC 筛选侧栏：Esc 收起
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    var f = document.querySelector('.ol-scope .ol-filter.open');
    if (f) f.classList.remove('open');
  }
});

// 筛选选项：勾选状态实时同步选中样式（服务端只渲染初始态）
document.addEventListener('change', function (e) {
  var input = e.target.closest('.ol-scope .ol-filter input[type=checkbox]');
  if (!input) return;
  var label = input.closest('.fchip, .szbox');
  if (label) {
    label.classList.toggle('on', input.checked);
    if (label.hasAttribute('aria-pressed')) label.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
  }
  // 行汇总回显：把该组已选值写到行头
  var fopen = input.closest('.fopen');
  var row = fopen && fopen.previousElementSibling;
  if (row && row.classList.contains('frow')) {
    var names = [...fopen.querySelectorAll('input:checked')].map(function (i) {
      var l = i.closest('.fchip, .szbox');
      if (!l) return i.value;
      // 只取文本节点，跳过数量徽标 <b>
      return [...l.childNodes].filter(function (n) { return n.nodeType === 3; })
        .map(function (n) { return n.textContent; }).join('').trim() || i.value;
    });
    var fv = row.querySelector('.fv');
    if (fv) {
      var chev = fv.querySelector('.chev');
      fv.innerHTML = names.length ? '<b class="sel"></b>' : 'All';
      if (names.length) fv.querySelector('.sel').textContent = names.join(', ');
      if (chev) fv.appendChild(chev);
    }
  }
});

// 排序下拉：宽度跟随当前选中项自适应（原生 select 默认按最长选项定宽）
(function () {
  function fit(sel) {
    var probe = document.createElement('span');
    var cs = getComputedStyle(sel);
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;' +
      'font:' + cs.font + ';letter-spacing:' + cs.letterSpacing;
    probe.textContent = (sel.options[sel.selectedIndex] || {}).text || '';
    document.body.appendChild(probe);
    sel.style.width = Math.ceil(probe.offsetWidth + 58) + 'px';   // 16 左 padding + 40 右箭头区 + 边框
    probe.remove();
  }
  function initAll() {
    document.querySelectorAll('.ol-scope .fbar select').forEach(function (sel) {
      if (sel.dataset.olFit) return;
      sel.dataset.olFit = '1';
      fit(sel);
      sel.addEventListener('change', function () { fit(sel); });
    });
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

// 列表页：一键返回顶部（滚过约一屏半才出现；懒查询以兼容编辑器 section 重载）
(function () {
  function toggle() {
    var btn = document.querySelector('.ol-scope .totop');
    if (btn) btn.classList.toggle('show', window.scrollY > window.innerHeight * 1.5);
  }
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ol-scope .totop')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();


// PC 右栏 You May Also Like：走 Shopify 官方推荐接口（复用底部相关推荐 section 渲染，最多5款）
(function () {
  function load() {
    var box = document.querySelector('.ol-scope .rel-sec');
    if (!box || box.dataset.olRecDone) return;
    var wrap = box.closest('.shopify-section');
    if (!wrap || !wrap.id) return;
    box.dataset.olRecDone = '1';
    var url = (box.dataset.recUrl || '/recommendations/products') +
      '?section_id=' + encodeURIComponent(wrap.id.replace('shopify-section-', '')) +
      '&product_id=' + box.dataset.recPid + '&limit=5&intent=related';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('.grid3');
        if (!grid || !grid.children.length) return;
        var target = box.querySelector('.grid3');
        if (target) target.innerHTML = grid.innerHTML;
      })
      .catch(function () {});
  }
  load();
  document.addEventListener('shopify:section:load', load);
})();

// PC 右栏折叠信息：把全宽「商品信息折叠」楼层搬进右栏挂载点（内容与移动端同源）
(function () {
  function mount() {
    if (!window.matchMedia('(min-width:1024px)').matches) return;
    var slot = document.querySelector('.ol-scope .pdp-more .accmount');
    var info = document.querySelector('.ol-scope .pinfo-sec');
    if (slot && info && !slot.contains(info)) slot.appendChild(info);
    var pslot = document.querySelector('.ol-scope .pdp-more .piecesmount');
    var pieces = document.querySelector('.ol-scope .pieces-sec');
    if (pslot && pieces && !pslot.contains(pieces)) pslot.appendChild(pieces);
  }
  mount();
  document.addEventListener('shopify:section:load', mount);
})();

// PC 详情页图库缩略图：点选跳转 + 滚动联动高亮
document.addEventListener('click', function (e) {
  var t = e.target.closest('.ol-scope .gthumb');
  if (!t) return;
  var gal = t.closest('.gal');
  var track = gal && gal.querySelector('.gtrack');
  if (!track) return;
  var vis = [].filter.call(gal.querySelectorAll('.gthumb'), function (x) { return !x.classList.contains('goff'); });
  var k = vis.indexOf(t);
  if (k >= 0) track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' });
});
document.querySelectorAll('.ol-scope .gtrack').forEach(function (track) {
  var gal = track.closest('.gal');
  if (!(gal && gal.querySelector('.gthumb'))) return;
  track.addEventListener('scroll', function () {
    var vis = [].filter.call(gal.querySelectorAll('.gthumb'), function (x) { return !x.classList.contains('goff'); });
    var i = Math.round(track.scrollLeft / track.clientWidth);
    vis.forEach(function (x, k) { x.classList.toggle('on', k === i); });
  }, { passive: true });
});

// 满减凑单提示：按档位行规则与当前商品价格动态计算（价格未达档→距下一档差额；超顶档→已解锁）
(function () {
  var nudge = document.querySelector('.ol-scope .tiernudge');
  var line = document.querySelector('.ol-scope .tierline');
  if (!nudge || !line) return;
  var tiers = [];
  (line.textContent.match(/\$[\d.,]+\s*Save\s*\$[\d.,]+/gi) || []).forEach(function (t) {
    var m = t.match(/\$([\d.,]+)\s*Save\s*\$([\d.,]+)/i);
    if (m) tiers.push({ spend: parseFloat(m[1].replace(/,/g, '')), save: parseFloat(m[2].replace(/,/g, '')) });
  });
  if (!tiers.length) return;
  tiers.sort(function (a, b) { return a.spend - b.spend; });
  window.olTierNudge = function (price) {
    var next = null, hit = null;
    tiers.forEach(function (t) { if (price >= t.spend) hit = t; else if (!next) next = t; });
    if (next) {
      nudge.innerHTML = 'Add $' + (next.spend - price).toFixed(2) +
        ' to unlock <b class="tier-hot">$' + next.save + '</b> off';
    } else if (hit) {
      nudge.innerHTML = '<b class="tier-hot">$' + hit.save + '</b> off unlocked';
    }
  };
  var pe = document.querySelector('.ol-scope .price');
  var pv = pe ? parseFloat(pe.textContent.replace(/[^\d.]/g, '')) : NaN;
  if (!isNaN(pv)) window.olTierNudge(pv);
})();

// 满减档位行：所有金额加深显示
document.querySelectorAll('.ol-scope .tierline').forEach(function (el) {
  el.innerHTML = el.innerHTML.replace(/\$[\d.,]+/g, '<b class="tier-amt">$&</b>');
});

// 列表页快速加购：点商品卡购物车图标 → 弹窗选颜色尺码再加入（PC 居中 / 移动端底部 3/4 屏）
(function () {
  var cache = {};
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function hide() {
    var el = document.querySelector('.olqa-overlay');
    if (el) el.style.display = 'none';
    document.body.style.overflow = '';
  }
  function zoom(imgs, start) {
    var z = document.querySelector('.olqa-zoom');
    if (!z) {
      z = document.createElement('div');
      z.className = 'olqa-zoom';
      z.innerHTML = '<button type="button" class="olqa-zoom-close" aria-label="Close">&#10005;</button>' +
        '<button type="button" class="olqa-zoom-prev" aria-label="Previous">&lsaquo;</button>' +
        '<button type="button" class="olqa-zoom-next" aria-label="Next">&rsaquo;</button>' +
        '<div class="olqa-zoom-track"></div>';
      document.body.appendChild(z);
      z.addEventListener('click', function (e) {
        var pn = e.target.closest('.olqa-zoom-prev') || e.target.closest('.olqa-zoom-next');
        if (pn) {
          var zt = z.querySelector('.olqa-zoom-track');
          zt.scrollBy({ left: e.target.closest('.olqa-zoom-next') ? zt.clientWidth : -zt.clientWidth, behavior: 'smooth' });
          return;
        }
        if (!e.target.closest('.olqa-zoom-track img')) z.style.display = 'none';
      });
    }
    var tr = z.querySelector('.olqa-zoom-track');
    tr.innerHTML = imgs.map(function (u) {
      return '<div class="olqa-zoom-cell"><img src="' + u + '" alt=""></div>';
    }).join('');
    z.style.display = 'flex';
    requestAnimationFrame(function () { tr.scrollLeft = start * tr.clientWidth; });
  }
  function overlay() {
    var el = document.querySelector('.olqa-overlay');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'olqa-overlay';
    el.innerHTML = '<div class="olqa-modal" role="dialog" aria-modal="true">' +
      '<button type="button" class="olqa-close" aria-label="Close">&#10005;</button>' +
      '<div class="olqa-body"></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('.olqa-close')) hide();
    });
    return el;
  }
  function render(p) {
    var el = overlay();
    el.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    var body = el.querySelector('.olqa-body');
    var optName = function (o) { return o.name || String(o); };
    var optValues = function (o, i) {
      if (o.values && o.values.length) return o.values;
      var vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      return vals;
    };
    var ci = -1;
    p.options.forEach(function (o, i) {
      var n = optName(o).toLowerCase();
      if (ci < 0 && (n.indexOf('color') >= 0 || n.indexOf('colour') >= 0)) ci = i;
    });
    var first = null;
    p.variants.forEach(function (v) { if (!first && v.available) first = v; });
    first = first || p.variants[0];
    var sel = p.options.map(function (o, i) { return first ? first.options[i] : null; });
    function variantOf() {
      var hit = null;
      p.variants.forEach(function (v) {
        if (!hit && v.options.every(function (val, i) { return sel[i] === val; })) hit = v;
      });
      return hit;
    }
    function imgsFor() {
      var arr = (p.images || []).slice();
      if (!arr.length && p.featured_image) arr = [p.featured_image];
      return arr;
    }
    function html() {
      var v = variantOf();
      var price = v ? v.price : p.price;
      var cmp = v ? v.compare_at_price : p.compare_at_price;
      var gi = imgsFor();
      var h = '<div class="olqa-media"><div class="olqa-track">' +
        gi.map(function (u) { return '<img src="' + u + '" alt="">'; }).join('') + '</div>';
      if (gi.length > 1) {
        var dn = Math.min(gi.length, 5);
        var dh = '';
        for (var dk = 0; dk < dn; dk++) dh += '<i' + (dk === 0 ? ' class="on"' : '') + '></i>';
        h += '<button type="button" class="olqa-gprev" aria-label="Previous">&lsaquo;</button>' +
          '<button type="button" class="olqa-gnext" aria-label="Next">&rsaquo;</button>' +
          '<div class="olqa-dots">' + dh + '</div>';
      }
      h += '</div>';
      h += '<div class="olqa-head"><a class="olqa-title" href="' + p.url + '">' + p.title + '</a>';
      h += '<div class="olqa-price"><b>' + money(price) + '</b>' + (cmp && cmp > price ? '<s>' + money(cmp) + '</s>' : '') + '</div></div>';
      h += '<div class="olqa-info">';
      p.options.forEach(function (o, i) {
        var vals = optValues(o, i);
        if (vals.length === 1 && vals[0] === 'Default Title') return;
        h += '<div class="olqa-optlbl">' + optName(o) + ': <span>' + (sel[i] || '') + '</span></div>';
        h += '<div class="olqa-opts" data-oi="' + i + '">';
        vals.forEach(function (val) {
          var cls = 'olqa-opt' + (sel[i] === val ? ' on' : '');
          var ok = p.variants.some(function (vv) {
            return vv.available && vv.options[i] === val &&
              vv.options.every(function (x, k) { return k === i || sel[k] === x; });
          });
          if (!ok) cls += ' off';
          var dv = String(val).replace(/"/g, '&quot;');
          if (i === ci) {
            var vi = null;
            p.variants.some(function (vv) {
              if (vv.options[i] === val && vv.featured_image) { vi = vv.featured_image.src; return true; }
              return false;
            });
            if (!vi) vi = p.featured_image || ((p.images || [])[0] || null);
            h += '<span class="' + cls + ' olqa-sw" data-v="' + dv + '" title="' + dv + '"' +
              (vi ? ' style="background-image:url(' + vi + ')"' : '') + '></span>';
          } else {
            h += '<span class="' + cls + '" data-v="' + dv + '">' + val + '</span>';
          }
        });
        h += '</div>';
      });
      h += '<button type="button" class="olqa-add"' + (v && v.available ? '' : ' disabled') + '>' +
        (v ? (v.available ? 'ADD TO CART' : 'SOLD OUT') : 'UNAVAILABLE') + '</button>';
      h += '<button type="button" class="olqa-buy"' + (v && v.available ? '' : ' disabled') + '>Buy it now</button>';
      h += '</div>';
      body.innerHTML = h;
      var tr = body.querySelector('.olqa-track');
      if (tr && v && v.featured_image && v.featured_image.position) {
        tr.scrollLeft = (v.featured_image.position - 1) * (tr.clientWidth || 1);
        requestAnimationFrame(function () {
          tr.scrollLeft = (v.featured_image.position - 1) * tr.clientWidth;
        });
      }
      if (tr) tr.addEventListener('scroll', function () {
        var total = tr.children.length;
        var dots = body.querySelectorAll('.olqa-dots i');
        var i = Math.round(tr.scrollLeft / tr.clientWidth);
        var d = total > 1 ? Math.round(i / (total - 1) * (dots.length - 1)) : 0;
        dots.forEach(function (x, k) { x.classList.toggle('on', k === d); });
      }, { passive: true });
    }
    html();
    var payWrap = null;
    function placePay() {
      if (!payWrap) return;
      var info = body.querySelector('.olqa-info');
      if (info && !info.contains(payWrap)) info.appendChild(payWrap);
      var vv = variantOf();
      var idEl = payWrap.querySelector('[name="id"]');
      if (idEl && vv) idEl.value = vv.id;
      var pb = payWrap.querySelector('[data-shopify="payment-button"]');
      if (pb && pb.children.length) {
        var fb = body.querySelector('.olqa-buy');
        if (fb) fb.style.display = 'none';
      }
    }
    fetch(p.url.split('?')[0] + '?section_id=ol-quick-buy')
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html2) {
        var doc2 = new DOMParser().parseFromString(html2, 'text/html');
        var pf = doc2.querySelector('.olqa-payform');
        if (!pf) return;
        payWrap = document.createElement('div');
        payWrap.className = 'olqa-pay';
        payWrap.appendChild(pf);
        placePay();
        if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
        var tries = 0;
        var timer = setInterval(function () {
          placePay();
          if (++tries >= 10) clearInterval(timer);
        }, 400);
      })
      .catch(function () {});
    var htmlBase = html;
    html = function () { htmlBase(); placePay(); };
    body.onclick = function (e) {
      var zi = e.target.closest('.olqa-track img');
      if (zi) {
        var zimgs = [].map.call(body.querySelectorAll('.olqa-track img'), function (im) { return im.src; });
        zoom(zimgs, [].indexOf.call(body.querySelectorAll('.olqa-track img'), zi));
        return;
      }
      if (e.target.closest('.olqa-gprev') || e.target.closest('.olqa-gnext')) {
        var tk = body.querySelector('.olqa-track');
        if (tk) tk.scrollBy({ left: e.target.closest('.olqa-gnext') ? tk.clientWidth : -tk.clientWidth, behavior: 'smooth' });
        return;
      }
      var opt = e.target.closest('.olqa-opt');
      if (opt && !opt.classList.contains('off')) {
        var oi = parseInt(opt.closest('.olqa-opts').dataset.oi, 10);
        sel[oi] = opt.dataset.v;
        html();
        return;
      }
      var add = e.target.closest('.olqa-add');
      var buy = e.target.closest('.olqa-buy');
      if (!add && !buy) return;
      var v = variantOf();
      if (!v || !v.available) return;
      if (buy) { window.location.href = '/cart/' + v.id + ':1'; return; }
      add.disabled = true;
      add.textContent = 'ADDING\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-link__count').forEach(function (b) {
            b.textContent = c.item_count;
            b.classList.remove('hidden');
          });
          document.dispatchEvent(new CustomEvent('ab:add_to_cart', {
            detail: { variant_id: v.id, handle: p.handle, source: 'quickadd' }
          }));
          add.textContent = 'ADDED \u2713';
          setTimeout(hide, 700);
        })
        .catch(function () { add.disabled = false; add.textContent = 'ADD TO CART'; });
    };
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.addbag');
    if (!btn || !btn.dataset.handle) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.dataset.handle;
    if (cache[handle]) { render(cache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) { cache[handle] = p; render(p); })
      .catch(function () {
        var f = btn.closest('form');
        if (f) f.submit();
      });
  }, true);
})();

// PC 页脚：订阅楼层移入页脚左列，社交图标移到邮箱下方（仅 ≥1024px；缩回窄屏时还原）
(function () {
  var socHome = null, socNext = null;
  function mount() {
    var pc = window.matchMedia('(min-width:1024px)').matches;
    var slot = document.querySelector('.ftr .fnews-slot');
    var news = document.querySelector('.news');
    var nl = document.querySelector('.nl-sec');
    var soc = document.querySelector('.fsoc');
    if (soc && !socHome) { socHome = soc.parentNode; socNext = soc.nextSibling; }
    if (pc) {
      if (slot && news && !slot.contains(news)) slot.appendChild(news);
      if (slot && soc && !slot.contains(soc)) slot.appendChild(soc);
      document.querySelectorAll('.ftr .faccp[hidden]').forEach(function (el) {
        el.setAttribute('data-ab-opened', '1');
        el.removeAttribute('hidden');
      });
    } else {
      if (nl && news && !nl.contains(news)) nl.appendChild(news);
      if (soc && socHome && soc.parentNode !== socHome) socHome.insertBefore(soc, socNext);
      document.querySelectorAll('.ftr .faccp[data-ab-opened]').forEach(function (el) {
        el.removeAttribute('data-ab-opened');
        var q = el.previousElementSibling;
        if (!q || q.getAttribute('aria-expanded') !== 'true') el.setAttribute('hidden', '');
      });
    }
  }
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(mount, 150); });
  mount();
  document.addEventListener('shopify:section:load', mount);
})();

// 购物车 Order note：默认收起，点击标题展开/收起
document.addEventListener('click', function (e) {
  var lb = e.target.closest('.ol-scope .notetgl');
  if (!lb) return;
  e.preventDefault();
  var ta = document.getElementById('ordernote');
  if (!ta) return;
  var open = ta.hasAttribute('hidden');
  if (open) { ta.removeAttribute('hidden'); ta.focus(); } else { ta.setAttribute('hidden', ''); }
  lb.setAttribute('aria-expanded', String(open));
  lb.classList.toggle('op', open);
});

// 详情页主图：点击放大预览（复用快速加购的 .olqa-zoom 全屏层，可左右翻页）
(function () {
  var track = document.querySelector('.ol-scope .pdp-layout .gtrack');
  if (!track) return;
  track.style.cursor = 'zoom-in';
  track.addEventListener('click', function (e) {
    var img = e.target.closest('img[data-zoom],img[data-ipos]');
    if (!img) return;
    var all = Array.prototype.filter.call(track.querySelectorAll('img'), function (el) {
      return !el.classList.contains('goff');
    });
    var start = all.indexOf(img);
    if (start < 0) start = 0;
    var urls = all.map(function (el) { return el.getAttribute('data-zoom') || el.currentSrc || el.src; });

    var z = document.querySelector('.olqa-zoom');
    if (!z) {
      z = document.createElement('div');
      z.className = 'olqa-zoom';
      z.innerHTML = '<button type="button" class="olqa-zoom-close" aria-label="Close">&#10005;</button>' +
        '<button type="button" class="olqa-zoom-prev" aria-label="Previous">&lsaquo;</button>' +
        '<button type="button" class="olqa-zoom-next" aria-label="Next">&rsaquo;</button>' +
        '<div class="olqa-zoom-track"></div>';
      document.body.appendChild(z);
      z.addEventListener('click', function (ev) {
        var pn = ev.target.closest('.olqa-zoom-prev') || ev.target.closest('.olqa-zoom-next');
        if (pn) {
          var zt = z.querySelector('.olqa-zoom-track');
          zt.scrollBy({ left: ev.target.closest('.olqa-zoom-next') ? zt.clientWidth : -zt.clientWidth, behavior: 'smooth' });
          return;
        }
        if (!ev.target.closest('.olqa-zoom-track img')) z.style.display = 'none';
      });
    }
    var tr = z.querySelector('.olqa-zoom-track');
    tr.innerHTML = urls.map(function (u) {
      return '<div class="olqa-zoom-cell"><img src="' + u + '" alt=""></div>';
    }).join('');
    z.style.display = 'flex';
    requestAnimationFrame(function () { tr.scrollLeft = start * tr.clientWidth; });
  });
})();




// 列表页 ajax 筛选：筛选提交、排序、已选条删除、Reset/Clear all 均走 section 局部渲染，
// 不整页刷新；地址栏用 pushState 同步，浏览器前进/后退可用。参考 A 主题的 faceted ajax 思路。
(function () {
  var busy = false;

  function root() { return document.querySelector('.ol-scope[data-plp-root]'); }

  function swap(html, url, push) {
    var r = root(); if (!r) { location.href = url; return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('.ol-scope[data-plp-root]');
    if (!next) { location.href = url; return; }
    var openRows = [].map.call(r.querySelectorAll('.fopen'), function (x) { return !x.hidden; });
    var drawerOpen = r.querySelector('.ol-filter') && r.querySelector('.ol-filter').classList.contains('open');
    r.innerHTML = next.innerHTML;
    // 还原展开状态与抽屉开合，避免筛选后面板整个收起
    [].forEach.call(r.querySelectorAll('.fopen'), function (x, i) { if (openRows[i]) x.hidden = false; });
    if (drawerOpen) { var f = r.querySelector('.ol-filter'); if (f) f.classList.add('open'); }
    if (push) history.pushState({ olPlp: 1 }, '', url);
    document.dispatchEvent(new Event('shopify:section:load'));
    var top = r.querySelector('.plp');
    if (top && top.getBoundingClientRect().top < 0) top.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function go(url, push) {
    if (busy) return; busy = true;
    var r = root(); if (r) r.classList.add('plp-loading');
    var sid = r && r.dataset.sectionId;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid || '');
    fetch(fetchUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (res) { if (!res.ok) throw 0; return res.text(); })
      .then(function (t) { swap(t, url, push !== false); })
      .catch(function () { location.href = url; })
      .then(function () { busy = false; var rr = root(); if (rr) rr.classList.remove('plp-loading'); });
  }

  // 筛选表单提交（View Results）
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.ol-scope[data-plp-root] form.ol-filter, .ol-scope[data-plp-root] form.f');
    if (!form) return;
    e.preventDefault();
    var qs = new URLSearchParams(new FormData(form));
    [].forEach.call(qs.keys ? [] : [], function () {});
    var clean = new URLSearchParams();
    qs.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    var s = clean.toString();
    go(location.pathname + (s ? '?' + s : ''));
  }, true);

  // 排序下拉（原来是 this.form.submit()，这里拦截 change 走 ajax）
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.ol-scope[data-plp-root] form.f select[name=sort_by]');
    if (!sel) return;
    e.preventDefault(); e.stopPropagation();
    var qs = new URLSearchParams(new FormData(sel.form));
    var clean = new URLSearchParams();
    qs.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    var s = clean.toString();
    go(location.pathname + (s ? '?' + s : ''));
  }, true);

  // 已选条删除 / Clear all / Reset：都是普通链接，改走 ajax
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.ol-scope[data-plp-root] .chipsf a.cf, .ol-scope[data-plp-root] .dact a.reset');
    if (!a) return;
    var href = a.getAttribute('href'); if (!href) return;
    e.preventDefault();
    go(href);
  }, true);

  window.addEventListener('popstate', function (e) {
    if (!root()) return;
    go(location.pathname + location.search, false);
  });
})();

// 详情页吸底购买栏：主加购按钮滚出视口后升起；点击时把已选变体带上，复用主表单的加购逻辑
(function () {
  var bar = document.querySelector('.ol-scope .pdp-sticky');
  var anchor = document.querySelector('.ol-scope [data-atc-anchor]');
  if (!bar || !anchor) return;
  var mainBtn = anchor.querySelector('button.btn.cart');
  if (!mainBtn) return;

  bar.hidden = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { bar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0); });
  }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });
  io.observe(anchor);

  // 变体切换后同步吸底栏价格（主区价格由已有逻辑更新，这里取现值即可）
  function sync() {
    var p = document.querySelector('.ol-scope .pdp-buy .price');
    var w = document.querySelector('.ol-scope .pdp-buy .was');
    var bp = bar.querySelector('.price'), bw = bar.querySelector('.was');
    if (p && bp) bp.textContent = p.textContent;
    if (bw) bw.textContent = w ? w.textContent : '';
    // 已选规格（颜色/尺码）同步到吸底栏
    var sel = document.querySelector('.ol-scope .pdp-buy select[name=id]');
    var meta = bar.querySelector('.ps-meta');
    if (sel && meta) {
      var opt = sel.options[sel.selectedIndex];
      var t = opt ? opt.textContent.trim() : '';
      meta.textContent = /default/i.test(t) ? '' : t;
    }
    var dis = mainBtn.disabled;
    var bb = bar.querySelector('.ps-btn');
    if (bb) { bb.disabled = dis; bb.textContent = dis ? 'SOLD OUT' : 'ADD TO BAG'; }
  }
  sync();
  document.addEventListener('change', function (e) {
    if (e.target.closest('.ol-scope .pdp-buy')) setTimeout(sync, 60);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ol-scope .optsw, .ol-scope .szbox')) setTimeout(sync, 120);
  }, true);

  bar.querySelector('.ps-btn').addEventListener('click', function () {
    // 未选尺码时先滚到尺码区提示，避免直接加错变体
    var need = document.querySelector('.ol-scope .pdp-buy .szbox.on, .ol-scope .pdp-buy .szgrid');
    var grid = document.querySelector('.ol-scope .pdp-buy .szgrid');
    if (grid && !grid.querySelector('.szbox.on')) {
      grid.scrollIntoView({ block: 'center', behavior: 'smooth' });
      grid.classList.add('flash'); setTimeout(function () { grid.classList.remove('flash'); }, 900);
      return;
    }
    mainBtn.click();
  });
})();

// 无障碍：role="button" 的伪按钮支持回车/空格触发（筛选入口、信息折叠行、色块、订单备注等）
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target.closest('.ol-scope [role="button"][tabindex]');
    if (!el) return;
    // 原生可交互元素与输入框交给浏览器默认行为
    if (/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) return;
    e.preventDefault();
    el.click();
  });
})();

// 无障碍：列表页 ajax 筛选后向读屏播报结果数量
(function () {
  function live() {
    var r = document.querySelector('.ol-scope[data-plp-root]');
    if (!r) return null;
    var el = document.getElementById('ol-plp-live');
    if (!el) {
      el = document.createElement('p');
      el.id = 'ol-plp-live';
      el.className = 'vh';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      r.parentNode.insertBefore(el, r);
    }
    return el;
  }
  function announce() {
    var el = live(); if (!el) return;
    var n = document.querySelectorAll('.ol-scope[data-plp-root] .plp .pcard').length;
    var chips = [].map.call(document.querySelectorAll('.ol-scope[data-plp-root] .chipsf a.cf.act'),
      function (a) { return a.textContent.replace('✕', '').trim(); });
    el.textContent = (chips.length ? 'Filters: ' + chips.join(', ') + '. ' : '') +
      (n ? n + ' products shown.' : 'No products found.');
  }
  // ajax 换完内容后 ol-theme 会派发 shopify:section:load
  document.addEventListener('shopify:section:load', function () { setTimeout(announce, 120); });
})();


// 无障碍：折叠行展开状态同步到 aria-expanded（筛选行与详情页信息折叠）
document.addEventListener('click', function (e) {
  var row = e.target.closest('.ol-scope .frow[role="button"], .ol-scope .acc[role="button"]');
  if (!row) return;
  setTimeout(function () {
    var panel = row.nextElementSibling;
    if (panel) row.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
  }, 30);
}, true);
